// @flow
import React from "react";
import styled, { css } from "styled-components";
import email from "../../images/email.png";
import tel from "../../images/phone.png";
import password from "../../images/pass.png";
import { fontSize, rtl } from "../common/styled-mixins";

const bg = {
  email,
  password,
  tel
};

const InputContainer = styled.div`
  direction: ${({ theme }) => theme.direction};
  position: relative;
  padding: ${props => (props.tab === "register" ? "4px 0" : "12px 0")};

  @media (max-width: 959px) {
    padding: ${props => (props.tab === "register" ? "4px 0" : "8px 0")};
  }

  ${({ theme }) =>
    theme.newIndex &&
    css`
      padding: 9px 0;
    `};
`;

const InputView = styled.input`
  width: 100%;
  min-height: 36px;
  ${rtl("padding-right", "7px")};
  ${rtl("padding-left", "47px")};
  font-size: ${fontSize(16)};
  line-height: 36px;
  pointer-events: auto;
  border: 1px solid #cfcfcf;
  border-radius: 3px;
  color: ${props => props.theme.inputColor};
  background-color: #f6f6f6;
  box-shadow: inset 0 2px 0 0 #e3e3e3;

  @media (max-width: 959px) {
    height: 32px;
  }

  :focus {
    outline: none;
  }

  ${({ theme }) =>
    theme.newIndex &&
    css`
      height: 50px;
      ${rtl("padding-left", "20px")};
      background-color: rgba(255, 255, 255, 0.25);
      border: none;
      border-radius: 25px;
      box-shadow: none;

      @media (max-width: 959px) {
        height: 40px;
      }

      :focus {
        border: 1px solid #ffffff;
        ${rtl("padding-left", "19px")};
      }

      &::placeholder {
        color: #ffffff;
      }

      &:-webkit-autofill,
      &:-webkit-autofill:hover,
      &:-webkit-autofill:focus {
        color: #ffffff;
        border: 1px solid yellow;
        box-shadow: 0 0 0px 1000px rgba(255, 255, 0, 0.5) inset;
        transition: background-color 5000s ease-in-out 0s;
      }
    `};
`;

const InputLabel = styled.label`
  display: block;
  width: 100%;
  position: absolute;
  top: ${props => (props.tab === "register" ? "4px" : "11px")};
  ${rtl("left", 0)};
  min-height: 38px;
  ${rtl("padding-left", "47px")};
  font: 16px/38px Roboto, Arial, sans-serif;
  ${rtl("text-align", "left")};
  pointer-events: none;
  background: url(${props => bg[props.type]}) no-repeat 12px center;

  @media (max-width: 959px) {
    top: ${props => (props.tab === "register" ? "1px" : "5px")};
  }

  ${({ theme }) =>
    theme.newIndex &&
    css`
      display: none;
    `};
`;

type Props = {
  tab: string,
  type: string,
  name: string,
  placeholder: string,
  id: string,
  required: string,
  value: string | number,
  onChange: () => void
};

function Input({
  tab,
  type,
  name,
  placeholder,
  id,
  onChange,
  value,
  autocomplete,
  required
}: Props) {
  return (
    <InputContainer tab={tab}>
      <InputView
        type={type}
        name={name}
        placeholder={placeholder}
        id={id}
        onChange={onChange}
        value={value}
        required={required}
        autocomplete={autocomplete}
      />
      <InputLabel tab={tab} type={type} htmlFor={id} />
    </InputContainer>
  );
}

export default Input;



// WEBPACK FOOTER //
// ./src/components/Auth/Input.js